<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>

      <h2 class="text-center">Send Message</h2>
    </div>
    <div class="row">
      <div class="col-md-12">
        <card>
          <form>
            <div class="row">
              <div class="col-md-6">
                <base-input
                  type="text"
                  label="Subject"
                  maxlength="50"
                  required="true"
                  placeholder="Subject"
                  v-model="subject"
                >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>Important</label>
                <p class="text-muted small">The important messages are displayed on the home page in the app</p>
                <select
                  v-model="important"
                  class="location form-control"
                  style="width:100%; color:white !important;"
                >
                  <option
                    style="color:black !important;"
                    v-for="value in ['no','yes']"
                    v-bind:key="value"
                  >{{ value }}</option
                  >
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <base-input
                  v-show="important === 'yes'"
                  type="datetime-local"
                  label="Expiration"
                  v-model="expires_on"
                  required
                ></base-input>
              </div>
            </div>
            <p class="mt-3"></p>
            <div class="row">
              <div class="col-md-6">
                <textarea
                  class="form-control"
                  style="padding: inherit; line-height:inherit;"
                  type="text"
                  rows="4"
                  placeholder="Message"
                  required="required"
                  v-model="message"
                >
                </textarea>
              </div>
            </div>
            <div class="row" style="margin:5px">
              <div class="col-md-6">
                <base-button
                  native-type="submit"
                  @click="sendMessage()"
                  type="primary"
                  class="btn-fill"
                  :disabled="loading"
                >Send</base-button>
              </div>
            </div>
          </form>
        </card>
      </div>
    </div>
    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>
<script>

import moment from "moment";

export default {
  components: {

  },
  data() {
    return {
      subject: "",
      important: "no",
      expires_on: moment().add(1, 'week').local().format('YYYY-MM-DDTHH:mm'),
      message: "",
      loading: false
    };
  },

  methods: {
    async sendMessage() {
      this.loading = true;
      let response = await this.$apiService.postCall("message/add-message", {
        subject: this.subject,
        important: this.important,
        expires_on: this.expires_on,
        message: this.message,
      });
      this.loading = false;

      await this.$apiService.notify("The message was sent successfully!");
    }
  }
};
</script>
